const state = {
  token: localStorage.getItem('token') || '',
  refreshToken: localStorage.getItem('refreshToken') || '',
  name: '',
  avatar: '',
  merchant: JSON.parse(localStorage.getItem('merchant') || '{}'),
  permissions: JSON.parse(localStorage.getItem('permissions') || '{}'),
  isFrozen: localStorage.getItem('isFrozen') === 'true',
  frozenMessage: localStorage.getItem('frozenMessage') || ''
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
    localStorage.setItem('token', token)
  },
  SET_REFRESH_TOKEN: (state, token) => {
    state.refreshToken = token
    localStorage.setItem('refreshToken', token)
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  },
  SET_MERCHANT: (state, merchant) => {
    state.merchant = merchant
    localStorage.setItem('merchant', JSON.stringify(merchant))
  },
  SET_PERMISSIONS: (state, permissions) => {
    state.permissions = permissions
    localStorage.setItem('permissions', JSON.stringify(permissions))
  },
  SET_FROZEN_STATUS: (state, { isFrozen, message }) => {
    state.isFrozen = isFrozen
    state.frozenMessage = message || ''
    localStorage.setItem('isFrozen', isFrozen ? 'true' : 'false')
    localStorage.setItem('frozenMessage', message || '')
  },
  CLEAR_USER: (state) => {
    state.token = ''
    state.refreshToken = ''
    state.merchant = {}
    state.permissions = {}
    state.isFrozen = false
    state.frozenMessage = ''
    localStorage.removeItem('token')
    localStorage.removeItem('refreshToken')
    localStorage.removeItem('merchant')
    localStorage.removeItem('permissions')
    localStorage.removeItem('isFrozen')
    localStorage.removeItem('frozenMessage')
  }
}

const getters = {
  token: state => state.token,
  refreshToken: state => state.refreshToken,
  merchant: state => state.merchant,
  permissions: state => state.permissions,
  name: state => state.name,
  avatar: state => state.avatar,
  isFrozen: state => state.isFrozen,
  frozenMessage: state => state.frozenMessage
}

const actions = {
  login({ commit }, userInfo) {
    return new Promise((resolve) => {
      const { token, refreshToken, merchant, permissions, is_frozen, frozen_message } = userInfo
      commit('SET_TOKEN', token)
      commit('SET_REFRESH_TOKEN', refreshToken)
      commit('SET_MERCHANT', merchant)
      commit('SET_PERMISSIONS', permissions || {})
      commit('SET_NAME', merchant.company_name)
      commit('SET_FROZEN_STATUS', { 
        isFrozen: is_frozen || merchant.status === 2, 
        message: frozen_message || '您的账户已被冻结，请联系泛海支付管理员' 
      })
      resolve()
    })
  },
  logout({ commit }) {
    return new Promise((resolve) => {
      commit('CLEAR_USER')
      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
